<template>
  <div
    id="context-menu"
    v-on-click-outside="closeContext"
    :class="value.class || ''"
    :style="style()"
  >
    <component :is="value.component" :context="value" @action="action" @close="closeContext" />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  const HEIGHT_OF_OPTION = 36;
  const DEFAULT_WIDTH = 120;

  export default {
    name: 'ContextMenu',
    data() {
      return {
        // if context menu opens by click - don't let it be counted as click-outside
        click: null,
      };
    },
    computed: {
      ...mapState({
        value: (state) => state.context.value,
      }),
      height() {
        if (this.value.height) return this.value.height;
        else if (this.value.options && this.value.optionsHeight)
          return this.value.optionsHeight * this.value.options || null;
        else if (this.value.options) return HEIGHT_OF_OPTION * this.value.options || null;
        return null;
      },
    },
    mounted() {
      window.addEventListener('resize', this.close);
      window.addEventListener('scroll', this.close);
    },
    methods: {
      ...mapActions('context', ['close', 'addAction']),
      style() {
        let style = {};
        if (this.value) {
          style.display = 'block';

          const margin = this.value.margin || 0;
          const height = this.height;

          const width = this.value.width || DEFAULT_WIDTH;

          style.height = `${height}px`;

          if (width + this.value.pageX >= window.innerWidth)
            style.left = this.value.pageX - width - margin + 'px';
          else style.left = this.value.pageX + margin + 'px';

          if (height + this.value.pageY >= window.innerHeight) {
            style.top = this.value.pageY - height - margin + 'px';
          } else style.top = this.value.pageY + margin + 'px';

          if (this.value.type === 'click') this.click = true;
        }
        return style;
      },

      action(val) {
        // Each 'val' should be an objects {type: namespacedString, value: anything},
        // where namespaced string looks like 'estimate/addRow' - vuex-like syntax.
        // Components will subscribe to state.context.action and perform operations
        // from action.type
        this.addAction(val);
      },
      closeContext() {
        if (this.click) {
          this.click = false;
        } else {
          this.close();
        }
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/context-menu';
</style>
